import { RequestMethod, Response, ResponseContentType } from '@angular/http';
import { saveAs } from 'file-saver/FileSaver';
import { Observable } from 'rxjs/Observable';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { _throw } from 'rxjs/observable/throw';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { omit } from '../../../core/util/utils';
import { RestrictedAccountObjectApiFacade } from '../restricted-account-object/restricted-account-object.api-facade';
import { ReportLayoutDto } from './report-layout.dto';
import { ReportLayout } from './report-layout.model';

export class ReportLayoutApiFacade extends RestrictedAccountObjectApiFacade<ReportLayout> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<ReportLayout> {
        return this.GET(`/accounts/${accountId}/reportlayouts/${id}`, options)
            .map(object => new ReportLayout(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<ReportLayout>> {
        return this.CGET(`/accounts/${accountId}/reportlayouts`, options)
            .map(objects => objects.map(object => new ReportLayout(object)));
    }

    create(accountId: string, reportLayout: ReportLayoutDto, options?: ApiRequestOptions): Observable<Response> {
        return this.POST(`/accounts/${accountId}/reportlayouts`, {
            'reportLayout': omit(reportLayout, 'localFileSystemPath')
        }, options);
    }

    update(accountId: string, id: string, reportLayout: ReportLayoutDto, options?: ApiRequestOptions): Observable<Response> {
        return this.PATCH(`/accounts/${accountId}/reportlayouts/${id}`, {
            'reportLayout': omit(reportLayout, 'localFileSystemPath')
        }, options);
    }

    sendContent(accountId: string, id: string, reportLayout: ReportLayoutDto): Observable<Response> {

        if (!reportLayout.localFileSystemPath) {
            return _throw(Error('localFileSystemPath is undefined'));
        }

        return fromPromise(this.pathToFormData(reportLayout.localFileSystemPath))
            .concatMap(formData => {
                const request = this.api.createRequest(
                    true,
                    `/accounts/${accountId}/reportlayouts/${id}/content`,
                    RequestMethod.Post
                );

                request.setBody(formData);
                // tslint:disable-next-line:no-string-literal
                request['headers'].delete('Content-type');
                return request.execute();
            });
    }

    protected async pathToFormData(path: string): Promise<FormData> {
        const formData = new FormData();
        const blob = await this.appFacade.filesystem.pathToBlob(path);
        formData.append(`file`, blob, 'file');
        return formData;
    }

    async getContent(reportLayout: ReportLayout): Promise<Blob> {

        if (reportLayout.localFileSystemPath) {

            try {
                return await this.appFacade.filesystem.pathToBlob(reportLayout.localFileSystemPath);
            } catch (e) {
                // the blob is not valid try to get it from the api
            }
        }

        return this.api.createRequest(
            true,
            `/accounts/${reportLayout.account}/reportlayouts/${reportLayout.id}/content`,
            RequestMethod.Get
        )
            .setResponseType(ResponseContentType.Blob)
            .execute()
            .map(response => response.blob())
            .toPromise();
    }

    async download(reportLayout: ReportLayout): Promise<void> {
        const blob = await this.getContent(reportLayout);
        saveAs(blob, reportLayout.entryPoint);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report-layout/report-layout.api-facade.ts